export class RequestDocumentDto {
  DocUrl: string;
  DocName: string;
}
